import PageBackTitle from "../../Component/PageBackTitle";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API_URL from "../../../src/Config";
import axios from "axios";
function EditDetectorType({ isSidebarExpanded }) {
  const [formData, setFormData] = useState({
    model_name: "",
    description: "",
    manufacturer: "",
    detected_gases: "",
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const navigate = useNavigate();
  const { id } = useParams();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchDataById = async () => {
      const authKey = localStorage.getItem("authKey");
  
      try {
        const response = await axios.get(
          `${API_URL}/api/get_gas_detector_type/${id}`,
          {
            headers: {
              Authorization: authKey,
            },
          }
        );
  
        if (response.status === 200 && response.data) {
          const data = response.data;
  
          setFormData({
            // model_name: data.model_name || "",
            // description: data.description || "",
            detected_gases: data.detected_gases || "",
            // manufacturer: data.manufacturer || "",
            created_at: data.created_at || "",
            updated_at: data.updated_at || "",
          });
        } else {
          setSnackbarMessage("Failed to fetch detector type.");
          setSeverity("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Fetch error:", error);
        setSnackbarMessage("Error fetching gas detector type.");
        setSeverity("error");
        setSnackbarOpen(true);
      }
    };
  
    if (id) {
      fetchDataById();
    }
  }, [id]);
  

  const handleSubmit = async (e) => {
    e.preventDefault();


    const payload = {
      // model_name : formData.model_name,
      // description : formData.description,
      // manufacturer : formData.manufacturer,
      detected_gases : formData.detected_gases
    };

    const authKey = localStorage.getItem("authKey");

    try {
      const response = await axios.put(
        `${API_URL}/api/update_gas_detector_type/${id}`,
        payload,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setSnackbarMessage("Gas detector type updated successfully!");
        setSeverity("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      } else {
        setSnackbarMessage("Failed to add gas detector type.");
        setSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage("Something went wrong.");
      setSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">Edit Gas Detector Type</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
          <form>
              {/* Name Field */}
              {/* <div className="form-group">
                <label>
                  Model Name <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    name="model_name"
                    value={formData.model_name}
                    onChange={handleChange}
                    placeholder="Enter Mode Name"
                  />
                </div>
              </div> */}

              {/* Description Field */}

              <div className="form-group">
                <label>
                  Detector type <span className="text-danger">*</span>
                </label>
                <div className="input-group">
                  <input
                    name="detected_gases"
                    value={formData.detected_gases}
                    onChange={handleChange}
                    placeholder="Enter Detector Type"
                  />
                </div>
                
              </div>

              {/* <div className="form-group">
                <label>Manufacturer</label>
                <div className="input-group">
                  <input
                    name="manufacturer"
                    value={formData.manufacturer}
                    onChange={handleChange}
                    placeholder="Enter a Manufacturer"
                  />
                </div>
              </div> */}
              {/* <div className="form-group">
                <label>Description</label>
                <div className="input-group">
                  <input
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter a Short Description"
                  />
                </div>
              </div> */}
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button className="data-form-save-button" type="submit" onClick={handleSubmit}>
                Save
              </button>
              <button
                type="button"
                className="data-form-cancel-button"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          onClose={handleSnackbarClose}
          severity={severity}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default EditDetectorType;
